module.exports = __webpack_public_path__ + "img/dyp10.e7f7dfd1.jpg";